(() => {
    const init = () => {
        const section = document.getElementById('faq-section');
        if (!section) return;

        section.dataset.singleAccordionInit = 'true';
        const accordionDetails = section.querySelectorAll('details[id^="Details-"]');

        accordionDetails.forEach((activeDetails) => {
            activeDetails.addEventListener('toggle', () => {
                if (!activeDetails.open) return;

                accordionDetails.forEach((details) => {
                    if (details !== activeDetails && details.open) {
                        details.open = false;
                        const summary = details.querySelector('summary');
                        if (summary) summary.setAttribute('aria-expanded', 'false');
                    }
                });
            });
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();